import { createFileRoute } from "@tanstack/react-router";
import { AgentAuthorizationConsent } from "@/features/dashboard/AgentAuthorizationConsent";

export const Route = createFileRoute("/_auth/agent-connect")({
  validateSearch: (search: Record<string, unknown>) => ({
    request: typeof search.request === "string" ? search.request : "",
  }),
  component: AgentConnectRoute,
});

function AgentConnectRoute() {
  const { request } = Route.useSearch();
  return <AgentAuthorizationConsent requestToken={request} />;
}
